<script lang="ts">
  import Loading from '@px/icons/Loading.svelte';

  let className = '';
  export {className as class};
  export let type: 'default' | 'text' | 'common' | 'primary' | 'warning' | 'danger' | 'ghost' | 'blue' = 'default';
  export let size: 'normal' | 'small' = 'normal';
  export let disabled = false;
  export let loading = false;
  export let href = null;
  export let target = '_self';
  export let style = '';
</script>

<style>
  button,
  a {
    display: inline-block;
    border: solid 1px;
    border-radius: 8px;
    padding: 0 24px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
  .small {
    padding: 0 16px;
    line-height: 32px;
  }
  button + :global(button) {
    margin-left: 6px;
  }
  button :global(svg) {
    display: inline-block;
    transform: scale(0);
    vertical-align: middle;
    -webkit-animation: loading-circle 1s infinite linear;
    animation: loading-circle 1s infinite linear;
    transition: transform 3s linear;
  }
  .default {
    border-color: #ccc;
    background: transparent;
    color: var(--T2);
  }
  :global(.dark) .default {
    color: var(--T1);
    border-color: rgba(255, 255, 255, 0.4);
  }
  .ghost {
    border-color: #9fb4e0;
    background: #e5eeff;
    color: var(--blue);
  }
  .ghost:hover {
    border-color: var(--blue);
    background: var(--blue);
    color: #fff;
    opacity: 1;
  }
  :global(.dark) .ghost {
    border-color: rgba(255, 255, 255, 0.4);
    background: transparent;
    color: var(--T2);
  }
  :global(.dark) .ghost:hover {
    border-color: #0055ff;
    background: #0055ff;
    color: #fff;
  }
  .default:hover {
    border-color: var(--blue);
    color: var(--blue);
  }
  .text {
    border-color: transparent;
    background: transparent;
    color: var(--blue);
  }
  .text:hover {
    opacity: 0.8;
  }
  .common {
    border-color: #9fb4e0;
    background: #e5eeff;
    color: var(--blue);
  }
  .common:hover {
    border-color: var(--blue);
    background: var(--blue);
    color: #fff;
    opacity: 1;
  }
  .blue {
    border-color: #003fe6;
    background: #003fe6;
    color: #fff;
  }
  .primary {
    border-color: var(--blue);
    background: var(--blue);
    color: #fff;
  }
  .warning {
    border-color: #ebaf1a;
    background: #ebaf1a;
    color: #fff;
  }
  .danger {
    border-color: #ff6666;
    background: #ff6666;
    color: #fff;
  }
  a:hover,
  button:hover {
    opacity: 0.8;
  }
  a.disabled,
  button:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  @keyframes loading-circle {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>

{#if href}
  <a
    class:disabled={disabled || loading}
    {href}
    class="f14 {className}"
    class:loading
    class:small={size === 'small'}
    class:default={type === 'default'}
    class:text={type === 'text'}
    class:common={type === 'common'}
    class:primary={type === 'primary'}
    class:warning={type === 'warning'}
    class:danger={type === 'danger'}
    class:ghost={type === 'ghost'}
    class:blue={type === 'blue'}
    {target}
    on:click
    {style}
  >
    <slot />
  </a>
{:else}
  <button
    disabled={disabled || loading}
    class="f14 {className}"
    class:loading
    class:small={size === 'small'}
    class:default={type === 'default'}
    class:text={type === 'text'}
    class:common={type === 'common'}
    class:primary={type === 'primary'}
    class:warning={type === 'warning'}
    class:danger={type === 'danger'}
    class:ghost={type === 'ghost'}
    class:blue={type === 'blue'}
    on:click
    {style}
  >
    {#if loading}
      <Loading />
    {/if}
    <slot />
  </button>
{/if}
